<!--
 * @Author: cts 308360781@qq.com
 * @Date: 2025-06-22 18:56:07
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-06-24 18:46:52
 * @FilePath: \web2\src\views\yunke\project\query.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-card class="box query">
    <el-form :model="query" ref="query" :inline="true">
      <el-form-item label="名称">
        <el-input
          v-model="query.q"
          placeholder="请输入楼盘名称"
          clearable
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" round @click="onSearch" icon="search"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div>
      <add-query @success="loadData"></add-query>
    </div>
  </el-card>

  <el-card class="box data" v-loading="loading">
    <el-table
      ref="table"
      :data="tableData.data"
      border
      stripe
      @sort-change="onSort"
    >
      <el-table-column label="开发商名称" prop="name" width="280"></el-table-column>
      <el-table-column label="手机号码" prop="mobile_tel" width="180"></el-table-column>
      <el-table-column label="ID" prop="orgcode" width="180"></el-table-column>
      <el-table-column label="直连系统类型" prop="exter_type" width="180"></el-table-column>
      <el-table-column label="驻场类型" prop="exter_resident_type" width="180"></el-table-column>
      <el-table-column label="开发商报备链接" prop="yk_recommend_link" min-width="280"></el-table-column>
      <el-table-column label="盟拓租户标识" prop="exter_org" width="180"></el-table-column>
      <el-table-column label="盟拓账号验证信息" prop="resident_password" width="180"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageCurrentChange"
      :current-page="query.pageIndex"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="tableData.counts"
    ></el-pagination>
  </el-card>
</template>

<script>
import AddQuery from "./query_dialog.vue";
export default {
  components: {
    AddQuery,
  },
  data() {
    return {
      loading: false,
      query: {
        pageIndex: 1,
        pageSize: 20,
        order: {
          sort: "",
          fieldName: "",
        },
        q: "",
      },
      tableData: {
        counts: 0,
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    /**
     * 搜索
     */
    onSearch() {
      this.query.pageIndex = 1;
      this.loadData();
    },
    /**
     * 分页页数更改
     */
    pageSizeChange(val) {
      this.query.pageSize = val;
      this.loadData();
    },

    /**
     * 分页页码更改
     */
    pageCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },

    /**
     * 排序
     */
    onSort(e) {
      if (e.prop) {
        this.query.sort = {
          order: e.order,
          prop: e.prop,
        };
        this.loadData();
      }
    },

    /**
     *
     */
    loadData() {
      this.loading = true;
      this.$http
        .post("admin/v1/yunkeprojectquery", this.query)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data;
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
